// extracted by mini-css-extract-plugin
export var arbiterBadgeContainer = "_r-0";
export var colorSwatch = "_r-5";
export var compactSwatch = "_r-7";
export var fillWidth = "_r-4";
export var iconButton = "_r-2";
export var iconWrapper = "_r-3";
export var shadow = "_r-6";
export var xs = "_r-1";